<ng-container *transloco="let t">
  @if (storageSpace$ | async; as storageSpace) {
    @if (!closed) {
      <div class="container mx-auto px-4 lg:px-8">
        @if (storageSpace === StorageSpace.LOW && showStorageWarningNotification === true) {
          <div
            appearance="warning"
            class="mb-3"
            data-testid="low-storage-alert"
            icon="@tui.triangle-alert"
            size="m"
            tuiNotification
            (close)="close()"
            (closeEvent)="showStorageWarningNotification = false">
            <div>
              {{ t('Votre espace de stockage est bientôt saturé.') }}
              <ng-container *ngTemplateOutlet="callToActionPaywallMail" />
            </div>
            <button iconStart="@tui.x" tuiIconButton type="button"></button>
          </div>
        }
        @if (storageSpace === StorageSpace.FULL) {
          <div
            appearance="negative"
            class="mb-3"
            data-testid="no-storage-alert"
            icon="@tui.triangle-alert"
            size="m"
            tuiNotification>
            <div>
              {{ t('Votre espace de stockage est saturé.') }}
              <ng-container *ngTemplateOutlet="callToActionPaywallMail" />
            </div>
          </div>
        }
        <ng-template #callToActionPaywallMail>
          <a tuiLink (click)="manageStorage()">
            {{ t('Gérer le stockage.') }}
          </a>
        </ng-template>
      </div>
    }
  }
</ng-container>
